import apiSlice from '../apiSlice';
import { GlobalFilterKeys } from '../types';
import { stripGlobalFilterKeys } from '../utils';

import {
  DetailedDiagnosticsParams,
  DetailedDiagnosticsResponse,
  InsightsFiltersResponse,
  InsightsMetricsParams,
  InsightsMetricsResponse,
  MapboxGeocodingRequestParams,
  MapboxGeocodingResponse,
  PerformanceMonitoring,
  PerformanceMonitoringSearchParams,
} from '@/features/offlineSalesOptimizer';
import { PaginationResponse } from '@/shared/utils/types';

const OFFLINE_SALES_OPTIMIZER_API = '/api/offline-sales-optimizer';

const offlineSalesOptimizerTags = apiSlice.enhanceEndpoints({
  addTagTypes: ['offline-sales-optimizer'],
});

const offlineSalesOptimizerApiSlice = offlineSalesOptimizerTags.injectEndpoints(
  {
    endpoints: (builder) => ({
      getInsightsFilters: builder.query<
        InsightsFiltersResponse,
        GlobalFilterKeys & { mediaPlanId?: number }
      >({
        query: (params) => ({
          url: `${OFFLINE_SALES_OPTIMIZER_API}/filters/`,
          method: 'GET',
          params: stripGlobalFilterKeys(params),
        }),
      }),

      getInsightsMetrics: builder.query<
        InsightsMetricsResponse,
        GlobalFilterKeys & InsightsMetricsParams
      >({
        query: (params) => ({
          url: `${OFFLINE_SALES_OPTIMIZER_API}/`,
          method: 'GET',
          params: stripGlobalFilterKeys(params),
        }),
      }),

      getPerformanceMonitoring: builder.query<
        PaginationResponse<PerformanceMonitoring>,
        GlobalFilterKeys & PerformanceMonitoringSearchParams
      >({
        query: (params) => ({
          url: `${OFFLINE_SALES_OPTIMIZER_API}/performance-monitoring/`,
          method: 'GET',
          params: stripGlobalFilterKeys(params),
        }),
      }),

      getDetailedDiagnostics: builder.query<
        DetailedDiagnosticsResponse,
        GlobalFilterKeys & DetailedDiagnosticsParams
      >({
        query: (data) => ({
          url: `${OFFLINE_SALES_OPTIMIZER_API}/detailed-diagnostics/`,
          method: 'POST',
          data: stripGlobalFilterKeys(data),
        }),
      }),

      getMapSearch: builder.query<
        MapboxGeocodingResponse,
        MapboxGeocodingRequestParams
      >({
        query: ({ searchText, ...params }) => ({
          url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${searchText}.json`,
          method: 'GET',
          params,
        }),
      }),
    }),
  }
);

export const {
  useGetDetailedDiagnosticsQuery,
  useGetInsightsFiltersQuery,
  useGetInsightsMetricsQuery,
  useGetPerformanceMonitoringQuery,
  useLazyGetMapSearchQuery,
} = offlineSalesOptimizerApiSlice;
